import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BButtonSubmitButton, BPhoneNumberField } from "Src/js/components/blain-form";
import { onMounted, ref } from 'vue';
import { IJoinRewardsStep, ILinkRewardsUserResponse, IVerifyUserData, RewardsReasonCode } from 'JS/types/rewards';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinRewardsForm',
  props: {
    joinRewardsErrorMessage: null
  },
  emits: ["close", "switch-page", "loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void
	(e: 'switch-page', page: IJoinRewardsStep, data?: IVerifyUserData): void
	(e: 'loading', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const { rewardsService } = useServices();

const phoneNumber = ref<string>("");
const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);





async function submitRewardsSignupData() {
	errorMessage.value = "";
	emit('loading', true);
	const results: ILinkRewardsUserResponse = await rewardsService.joinRewards(phoneNumber.value);
	if (results.success) {
		window.blainGtmDataLayer.push({
			'event': "create_rewards"
		});
		emit('switch-page', 'success');
	} else {
		switch (results.reasonCode) {
			case RewardsReasonCode.CUSTOMER_HAS_REWARDS:
				emit('switch-page', 'customer-has-rewards');
				break;
			case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_LINKED:
				emit('switch-page',
					'account-in-use',
				 	{ phone: results.phone, email: results.email, variant: 'account-in-use', redactedData: 'email' }
				);
				break;
			case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_EXISTS:
				emit('switch-page',
					'verification-join',
					{ phone: results.phone, email: results.email, variant: 'verification-join', redactedData: 'email' }
				);
				break;
			case RewardsReasonCode.SESSION_M_ERROR:
				bugsnagClient.notify("SessionM error occured while attempting to Join Rewards.");
			default:
				errorMessage.value = results.errorMessage;
		}
	}
	emit('loading', false);
}

onMounted(()=> {
	headerFocuser.value?.focus();
});


return { __sfc: true,rewardsService, phoneNumber, errorMessage, headerFocuser, emit, submitRewardsSignupData, validation, BForm, ErrorBanner, Icon, LinkButton, BButtonSubmitButton, BPhoneNumberField }
}

})